import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import { dividerClasses } from '@mui/material/Divider';
import { listClasses } from '@mui/material/List';
import ListItemIcon, { listItemIconClasses } from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MuiMenuItem from '@mui/material/MenuItem';
import { paperClasses } from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Fragment, useState } from 'react';
import MenuButton from './Menu/MenuButton';
import { useLogoutMutation } from '@store/api/authEndpoints';
import { useLocalization } from '@lib/localization';

const OptionsMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [logout] = useLogoutMutation();
  const open = Boolean(anchorEl);
  const { t } = useLocalization();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <Fragment>
      <MenuButton aria-label="Open menu" onClick={handleClick} sx={menuButtonStyles}>
        <MoreVertRoundedIcon />
      </MenuButton>
      <Menu
        anchorEl={anchorEl}
        id="menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        sx={menuStyles}
      >
        <MenuItem onClick={handleLogout} sx={menuItemStyles}>
          <ListItemText>{t('Logout')}</ListItemText>
          <ListItemIcon>
            <LogoutRoundedIcon fontSize="small" />
          </ListItemIcon>
        </MenuItem>
      </Menu>
    </Fragment>
  );
};

const MenuItem = styled(MuiMenuItem)({
  margin: '2px 0',
});

const menuButtonStyles = {
  borderColor: 'transparent',
};

const menuStyles = {
  [`& .${listClasses.root}`]: {
    padding: '4px',
  },
  [`& .${paperClasses.root}`]: {
    padding: 0,
  },
  [`& .${dividerClasses.root}`]: {
    margin: '4px -4px',
  },
};

const menuItemStyles = {
  [`& .${listItemIconClasses.root}`]: {
    ml: 'auto',
    minWidth: 0,
  },
};

export default OptionsMenu;
